// Liga/pausa uma campanha (só com company.publish). Mostra o estado real: enviando → pedido registrado.
import { useState } from 'react'
import type { CampaignListItem } from '@impulso/shared/api/insights'
import { errorMessage } from '../../lib/api'
import { useCan } from '../../lib/company'
import { Switch } from '../../ui'
import { useToast } from '../../ui/toast'
import { useSetCampaignStatus } from '../insights/api'

export function CampaignStatusSwitch({ companyId, campaign, showLabel }: { companyId: string; campaign: Pick<CampaignListItem, 'campaignId' | 'name' | 'status' | 'connectionStatus'>; showLabel?: boolean }) {
  const canPublish = useCan('company.publish')
  const toast = useToast()
  const m = useSetCampaignStatus(companyId)
  const [pending, setPending] = useState<'active' | 'paused' | null>(null)
  if (campaign.status === 'draft' || campaign.status === 'removed') return <span className="small muted">—</span>
  const on = (pending ?? campaign.status) === 'active'
  const disabled = !canPublish || m.isPending || campaign.connectionStatus !== 'active'
  const change = (v: boolean) => {
    const status = v ? 'active' : 'paused'
    setPending(status)
    m.mutate({ campaignId: campaign.campaignId, status }, {
      onSuccess: () => toast(status === 'paused' ? `Pedido enviado: pausando “${campaign.name}”. Leva alguns segundos.` : `Pedido enviado: ligando “${campaign.name}”. Leva alguns segundos.`),
      onError: (err) => toast(errorMessage(err)),
      onSettled: () => setPending(null),
    })
  }
  const title = !canPublish ? 'Você não tem permissão para ligar ou pausar campanhas' : campaign.connectionStatus !== 'active' ? 'Reconecte a conta para mudar esta campanha' : undefined
  return (
    <span className="row" style={{ gap: 8 }} title={title}>
      {showLabel && <span className="small muted">{m.isPending ? 'Enviando…' : on ? 'Rodando' : 'Pausada'}</span>}
      <Switch on={on} onChange={change} label={`Ligar ou pausar ${campaign.name}`} disabled={disabled} />
    </span>
  )
}
